module.exports = __webpack_public_path__ + "static/media/21-6.fdf9e984.mp3";